import { apiClient } from "../../../lib/api-client";
import { API_PATHS } from "../../../config/api";
import { App } from "../../../types/app";

export const uploadService = {
  generateUploadUrl: async (contentLength: number): Promise<{
    data: { url: string; fields: Record<string, string> };
    serverFileName: string;
  }> => {
    return apiClient.post(API_PATHS.GENERATE_UPLOAD_URL, {
      content_length: contentLength,
    });
  },

  createApp: async (appData: Partial<App>): Promise<App> => {
    return apiClient.post(API_PATHS.UPLOAD_ITEM, appData);
  },

  updateApp: async (appData: Partial<App> & { app_id?: string | number }): Promise<App> => {
    const updateData = appData.app_id 
      ? appData
      : { ...appData, app_id: appData.id };
    return apiClient.patch(API_PATHS.UPLOAD_ITEM, updateData);
  },

  deleteApp: async (appId: string | number): Promise<void> => {
    return apiClient.post(API_PATHS.DELETE_UPLOAD_ITEM, { app_id: appId });
  },

  getAppsByProject: async (projectId: string | number): Promise<App[]> => {
    return apiClient.post(API_PATHS.GET_APPS_BY_PROJECT, { project_id: projectId });
  },
};

export default uploadService;
